import http from '@root/utils/axios/admin';

let state = {
    GameTrailersList: [],
    MostGameTrailersList: [],
    GameVideosNewReleasesList: [],
    GameVideosMostAnticipatedList: [],
    GameTrailer: {
        data: {},
        error: {}
    }
}

let actions = {

    fetchGameTrailersList({ commit }, filter = {}) {
        return new Promise((resolve, reject) => {
            http.get('subscriber/game-trailers', { params: filter }).then((response) => {
                commit('setGameTrailersList', response.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },
    fetchMostGameTrailersList({ commit }, filter = {}) {
        return new Promise((resolve, reject) => {
            http.get('subscriber/popular-game-trailers', { params: filter }).then((response) => {
                commit('setMostGameTrailersList', response.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },

    fetchGameTrailer({ commit }, id) {
        return new Promise((resolve, reject) => {
            http.get('subscriber/game-trailers/' + id).then((response) => {
                commit('setGameTrailer', response.data.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },


    fetchGameVideosNewReleases({ commit }, filter = {}) {
        return new Promise((resolve, reject) => {
            http.get('subscriber/source/games/videos/new-releases', { params: filter }).then((response) => {
                commit('setGameVideosNewReleasesList', response.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },
    fetchGameVideosMostAnticipated({ commit }, filter = {}) {
        return new Promise((resolve, reject) => {
            http.get('subscriber/source/games/videos/most-anticipated', { params: filter }).then((response) => {
                commit('setGameVideosMostAnticipated', response.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },



}


let mutations = {
    setGameTrailersList(state, data) {
        state.GameTrailersList = data;
    },
    setMostGameTrailersList(state, data) {
        state.MostGameTrailersList = data;
    },
    setGameTrailer(state, data) {
        state.GameTrailer.data = data;
    },
    setGameVideosNewReleasesList(state, data) {
        state.GameVideosNewReleasesList = data;
    },
    setGameVideosMostAnticipated(state, data) {
        state.GameVideosMostAnticipatedList = data;
    }
}

export default {
    state,
    actions,
    mutations
}